import Table from 'component/Table/table'
import { useLocationInfo } from 'context/location'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { CurrencyFormat } from 'utils'
import Api from 'utils/api'

const CampaignHeaders = [
  { name: 'Name', accessor: 'name' },
  { name: 'Subscriber', accessor: 'subscriber' },
  { name: 'Revenue', accessor: 'revenue' },
]

function CampaignList({location}) {
  // const { location } = useLocationInfo()
  const [campaigns, setCampaigns] = useState([])

  const CampaignRows = campaigns.map((campaign) => ({
    name: campaign.name,
    subscriber: campaign.passes.length,
    revenue: CurrencyFormat({
      amount: campaign.total_amount,
      currency: location.basic_info?.currency_code,
    }),
  }))

  const getCampaign = async () => {
    const { response } = await Api(
      '/reports/location/campaign_overview?location_id=' + location._id,
      'get'
    )
    if (response) setCampaigns(response.data)
  }

  const onLoad = () => {
    getCampaign()
  }
  useEffect(onLoad, [])

  return (
    <div class='my-6'>
      <div class='flex items-center justify-between'>
        <div>
          <div class='mb-4 font-bold text-gray-900 lg:text-2xl'>Business</div>
        </div>
      </div>
      <Table
        columns={CampaignHeaders}
        rows={CampaignRows}
        fixedHeader
        height={400}
      />
    </div>
  )
}

export default CampaignList
